(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const isBadgeContainer = (element) => (
    element &&
    element.tagName === 'DIV' &&
    Array.from(element.children).filter((child) => child.tagName === 'SPAN').length > 1
  );

  const findSummaryBadgeContainer = (root) => {
    const summaryContent = root.querySelector('[data-conversion-slot="quick-buying-summary"] .product-conversion__summary-content')
      || root.querySelector('[data-conversion-slot="quick-buying-summary"]');

    if (!summaryContent) return null;

    return [summaryContent, ...Array.from(summaryContent.querySelectorAll('div'))].find(isBadgeContainer);
  };

  const hydrateGlanceCard = (root) => {
    const glanceBadges = root.querySelector('[data-conversion-glance-badges]');
    if (!glanceBadges) return;

    const badgeContainer = findSummaryBadgeContainer(root);
    if (!badgeContainer) return;

    if (glanceBadges.querySelector('span')) {
      badgeContainer.remove();
    } else {
      glanceBadges.replaceChildren(badgeContainer);
    }
  };

  const setActiveLink = (links, activeId) => {
    links.forEach((link) => {
      const isActive = link.hash === `#${activeId}`;
      if (isActive) {
        link.setAttribute('aria-current', 'location');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  };

  const initProductSections = (root) => {
    const links = Array.from(root.querySelectorAll('.sa-product-sections__nav a[href^="#"]'));
    const sections = links
      .map((link) => document.getElementById(link.hash.slice(1)))
      .filter(Boolean);

    if (!links.length || !sections.length) return;

    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        const scrollTarget = target.classList.contains('sa-product-sections__anchor')
          ? target.closest('h2, h3, h4') || target
          : target;
        const topOffset = window.matchMedia('(max-width: 991px)').matches ? 92 : 132;
        const top = scrollTarget.getBoundingClientRect().top + window.scrollY - topOffset;

        event.preventDefault();
        window.scrollTo({
          top: Math.max(0, top),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
        target.focus({ preventScroll: true });
        history.pushState(null, '', link.hash);
        setActiveLink(links, target.id);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visibleEntry) {
            setActiveLink(links, visibleEntry.target.id);
          }
        },
        {
          rootMargin: '-24% 0px -58% 0px',
          threshold: [0.15, 0.35, 0.6]
        }
      );

      sections.forEach((section) => observer.observe(section));
    }
  };

  const initPaymentOptions = (root) => {
    const panel = root.querySelector('[data-sa-payment-options]');
    if (!panel) return;

    const sectionRoot = root.closest('[id^="MainProduct-"]');
    const sectionId = sectionRoot?.id || 'product';
    panel.id = panel.id || `sa-product-payment-options-${sectionId}`;

    const syncMoreOptions = () => {
      const moreOptions = root.querySelector('.shopify-payment-button__more-options');
      if (!moreOptions) return false;

      moreOptions.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
      moreOptions.setAttribute('aria-controls', panel.id);

      return true;
    };

    const openPaymentPanel = (moreOptions) => {
      panel.hidden = false;
      moreOptions.setAttribute('aria-expanded', 'true');
      moreOptions.setAttribute('aria-controls', panel.id);

      const firstOption = panel.querySelector('[data-sa-payment-option]');
      if (firstOption) firstOption.focus({ preventScroll: true });
    };

    if (root.dataset.saPaymentOptionsDelegateBound !== 'true') {
      root.dataset.saPaymentOptionsDelegateBound = 'true';

      root.addEventListener('click', (event) => {
        const selectedOption = event.target.closest('[data-sa-payment-option]');

        if (selectedOption && panel.contains(selectedOption)) {
          const moreOptions = root.querySelector('.shopify-payment-button__more-options');
          if (!moreOptions) return;

          moreOptions.dataset.saAllowCheckout = 'true';
          moreOptions.click();
          window.setTimeout(() => {
            delete moreOptions.dataset.saAllowCheckout;
          }, 0);
          return;
        }

        const moreOptions = event.target.closest('.shopify-payment-button__more-options');
        if (!moreOptions || !root.contains(moreOptions)) return;
        if (moreOptions.dataset.saAllowCheckout === 'true') return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openPaymentPanel(moreOptions);
      }, true);
    }

    syncMoreOptions();
    if (!('MutationObserver' in window)) return;

    const observer = new MutationObserver(() => {
      syncMoreOptions();
    });

    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 30000);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-page-section--conversion').forEach(hydrateGlanceCard);
    document.querySelectorAll('.product-page-section--conversion').forEach(initPaymentOptions);
    document.querySelectorAll('[data-sa-product-sections]').forEach(initProductSections);
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.product-page-section--conversion').forEach(hydrateGlanceCard);
    event.target.querySelectorAll('.product-page-section--conversion').forEach(initPaymentOptions);
    event.target.querySelectorAll('[data-sa-product-sections]').forEach(initProductSections);
  });
})();
